import {
  Box,
  Modal,
  ModalCloseButton,
  Spinner,
  theme,
  useMediaQuery,
} from '@everlywell/ui-kit';
import { GatsbyImage } from 'gatsby-plugin-image';
import { isNull } from 'lodash-es';
import React, { useRef } from 'react';
import analytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import { ImageType } from 'utils/types';

export type JustunoLoaderProps = {
  mobileBackgroundImage: ImageType | null;
  desktopBackgroundImage: ImageType | null;
  backgroundColor?: Queries.Maybe<string>;
};

/**
 *
 * This loader is been trigger from Justuno Platform.
 * over there you should write:
 *
 * At the start Code Block
 * loader = document.querySelector("#justuno-loader-id")
 * if(loader) {
 *    loader.style = 'display: flex'
 * }
 *
 * At the end of the code block
 * loader = document.querySelector("#justuno-loader-id")
 * if(loader) {
 *   loader.style = 'display: none'
 * }
 */

const JustunoLoader = (props: JustunoLoaderProps) => {
  const ModalRef = useRef<HTMLDivElement>(null);
  const { mobileBackgroundImage, desktopBackgroundImage } = props;
  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.tablet})`);
  if (isNull(mobileBackgroundImage) || isNull(desktopBackgroundImage)) {
    return null;
  }

  const handleOnClose = () => {
    if (ModalRef.current) {
      analytics.track({
        event: ANALYTICS.EVENTS.CLICKED_BUTTON,
        data: {
          label: 'Close justuno loader',
        },
      });
      ModalRef.current.style.display = 'none';
    }
  };

  const bgImage = isMobile ? mobileBackgroundImage : desktopBackgroundImage;
  return (
    <Modal
      isCentered
      closeOnEsc={false}
      closeOnOverlayClick={false}
      isOpen
      onClose={handleOnClose}
    >
      <Box
        ref={ModalRef}
        alignItems="center"
        background={props.backgroundColor || 'moonlight.base'}
        data-testid="justuno-loader"
        display="none"
        height="100vh"
        id="justuno-loader-id"
        justifyContent="center"
        left={0}
        position="fixed"
        top={0}
        width="100vw"
        zIndex={3}
      >
        <ModalCloseButton zIndex={1} onClick={handleOnClose} />
        <Box
          data-testid="background-image"
          height="100%"
          left="0"
          position="absolute"
          top="0"
          width="100%"
          zIndex={0}
        >
          <GatsbyImage
            style={{
              height: '100%',
              width: '100%',
            }}
            image={bgImage.gatsbyImageData}
            objectFit={isMobile ? 'contain' : 'cover'}
            objectPosition={isMobile ? 'bottom' : 'center'}
            alt=""
          />
        </Box>
        <Spinner color="tints.white" />
      </Box>
    </Modal>
  );
};

export default JustunoLoader;
